module.exports = __webpack_public_path__ + "static/media/conversation.20c665b9.svg";